

(function() {
  setTimeout(function() {
    // Force first thumbnail to be active every time variant changes
    document.addEventListener('variant:changed', function() {
      setTimeout(function() {
        // Find all visible thumbnails
        const thumbs = document.querySelectorAll('.m-product-media--slider__thumbnails .swiper-slide');
        let firstVisible = null;
        
        thumbs.forEach(thumb => {
          if (window.getComputedStyle(thumb).display !== 'none') {
            if (!firstVisible) firstVisible = thumb;
          }
        });
        
        // Remove active class from all
        thumbs.forEach(thumb => {
          thumb.classList.remove('swiper-slide-thumb-active', 'active');
        });
        
        // Add active class to first visible
        if (firstVisible) {
          firstVisible.classList.add('swiper-slide-thumb-active', 'active');
          
          // Also update main image to first thumbnail's index
          const index = firstVisible.getAttribute('data-index');
          const mainSlider = document.querySelector('.m-media-gallery__inner .swiper-container');
          if (mainSlider && mainSlider.swiper) {
            mainSlider.swiper.slideTo(parseInt(index), 300);
          }
        }
      }, 200);
    });
    
    // Also run once at start
    setTimeout(function() {
      const event = new Event('variant:changed');
      document.dispatchEvent(event);
    }, 500);
  }, 1000);
})();

// DEBUG: Check media IDs
setTimeout(function() {
  console.log('🔍 Checking media IDs:');
  
  const mainSlides = document.querySelectorAll('.m-media-gallery__list .swiper-slide');
  const thumbSlides = document.querySelectorAll('.m-product-media--slider__thumbnails .swiper-slide');
  
  console.log('Main slide media IDs:');
  mainSlides.forEach((slide, i) => {
    console.log(`  Main ${i}: ${slide.getAttribute('data-media-id')}`);
  });
  
  console.log('Thumbnail media IDs:');
  thumbSlides.forEach((slide, i) => {
    console.log(`  Thumb ${i}: ${slide.getAttribute('data-media-id')}`);
  });
}, 2000);


